var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.829113 2.429L11.6624 8.4725C12.0264 8.675 12.4973 8.771 12.9711 8.771C13.4449 8.771 13.9158 8.675 14.2798 8.4725L25.1131 2.429C25.8194 2.0345 26.4868 0.5 25.1911 0.5H0.752558C-0.543109 0.5 0.124225 2.0345 0.829113 2.429ZM25.441 5.7335L14.2798 11.774C13.7887 12.041 13.4449 12.0725 12.9711 12.0725C12.4973 12.0725 12.1536 12.041 11.6624 11.774C11.1713 11.507 1.35922 6.1655 0.557558 5.732C-0.00577539 5.426 2.33432e-06 5.7845 2.33432e-06 6.0605V17C2.33432e-06 17.63 0.817558 18.5 1.44445 18.5H24.5556C25.1824 18.5 26 17.63 26 17V6.062C26 5.786 26.0058 5.4275 25.441 5.7335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.6710dc02c20e76b4e831cb13b760b803.svg";
export { ForwardRef as ReactComponent };